import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import AlertIconFilled from "_+_Portal/assets/images/generico/AlertIconFilled";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { PortalContext } from "_+_Portal/context/Provider";
import CardAusente from "_+_Portal/_-_Autocheckin/components/genericos/CardAusente/CardAusente";
import CardCheck from "_+_Portal/_-_Autocheckin/components/genericos/CardCheck/CardCheck";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import ModalErrorAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalErrorAutoT/ModalErrorAutoT";
import { filaVirtualReset } from "_+_Portal/_-_Autocheckin/context/action/filaVirtual";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsGetTurnosPacienteDelDiaQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  BodyContainerP5,
  ButtonP5,
  ContainerButton,
  ContainerP5,
  ContainerSinTurno,
} from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { OrderTurnos } from "../PagesFun";
import { showToaster } from "global/context/action/toaster/toaster";
import ModalCentro from "_+_Portal/_-_Autocheckin/components/genericos/ModalCentro/ModalCentro";

const TurnosDelDia = () => {
  // -------------------------  useContex  ----------------------------
  const {
    turnosAutoCheckInState,
    turnosSeleccionadosDispatch,
    pasoDispatch,
    turnosAutoCheckInDispatch,
    filaVirtualDispatch,
    puntoControlDispatch,
    textosAutoCheckinState,
  } = useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);
  const { modalDispatch, toasterDispatch } = useContext(GlobalContext);
  // -------------------------  useContex  ----------------------------

  // -------------------------  constants  ----------------------------
  let config = localStorage.getItem("config");

  let initialData = turnosAutoCheckInState.turnosAutoCheckIn.data;
  if (initialData !== false) {
    initialData = initialData.filter((e) => !e.presente);
  }
  const history = useHistory();
  const idPacFamiliar = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo
    : false;
  let filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  let minutosToleranciaRecepcion =
    JSON.parse(config)?.minutosToleranciaRecepcion;
  let minRecepcionVariosTurnos = JSON.parse(config)?.minRecepcionVariosTurnos;
  let descHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.descripcion;
  const centroQR = sessionStorage.getItem("centroID");
  // -------------------------  constants  ----------------------------

  // -------------------------  useStates  ----------------------------
  const [turnos, setTurnos] = useState(initialData);
  const [loading, setLoading] = useState(true);
  // -------------------------  useStates  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleClickButton = () => {
    // No te olvides de el error horario
    let turnosRechazados = turnos.filter((e) => !e.checkin);
    let turnosSeleccionados = turnos.filter(
      (e) => e.selected && !(e.type === "ausente") && e.checkin
    );
    let turnosSinAusente = turnos.filter(
      (e) => !(e.type === "ausente") && e.idCentro.toString() === centroQR
    );

    if (turnosRechazados.length > 0) {
      setTurnosSeleccionado(turnosRechazados)(turnosSeleccionadosDispatch);
      setLoading(true);
      const idTipoPuntoControl = 6;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    } else if (turnosSeleccionados.length > 0) {
      setTurnosSeleccionado(turnosSeleccionados)(turnosSeleccionadosDispatch);
      if (turnosSeleccionados.length < turnosSinAusente.length) {
        showModalDiaHoy(
          <ModalAutoT
            dissmiss={dissmiss}
            desc={
              "Te falta seleccionar algún turno. ¿Querés avanzar con la recepción de tus otros turnos?"
            }
            title={"Recepción"}
            textBtnOne={"SI"}
            textBtnTwo={"NO"}
            handleChange={{
              btnOne: () => {
                dissmiss();
                // setPaso("UbicacionActual")(pasoDispatch);
                setPaso("NumeroAfiliado")(pasoDispatch);
              },
              btnTwo: () => {
                dissmiss();
              },
            }}
          />,
          "Información"
        );
      } else {
        let turnosCentro = turnosSeleccionados.filter(
          (e) => e.idCentro.toString() === centroQR
        );
        if (turnosCentro.length === 0) {
          //lo mando al primero, no tengo forma con los cambios que pidio gabi.b
          sessionStorage.setItem(
            "otroCentro",
            JSON.stringify(turnosSeleccionados[0].coordenadaGps)
          );
          setPaso("OtroCentro")(pasoDispatch);
        } else {
          setPaso("NumeroAfiliado")(pasoDispatch);
        }
      }
    } else {
      showModalDiaHoy(
        <ModalErrorAutoT
          dissmiss={dissmiss}
          errorMsg={"Debe seleccionar al menos un turno."}
        />
      );
    }
  };

  const volver = () => {
    setPaso("Home")(pasoDispatch);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const showModalDiaHoy = (content, title) => {
    showModal(
      content,
      title,
      dissmiss,
      false,
      {},
      "centro",
      true
    )(modalDispatch);
  };

  const handleSeleccionar = (item, isSelected) => {
    if (item.idCentro.toString() !== centroQR) {
      showModal(
        <ModalCentro item={item} />,
        "Turno en otra sede",
        dissmiss,
        false,
        {},
        "centro",
        true
      )(modalDispatch);
    } else {
      const newTurnos = turnos.map((element, key) => {
        if (element.idturno === item.idturno) {
          if (element?.type === "fueraRangoHorario") {
            showToaster(
              {
                texto: descHorario,
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
          } else {
            element.selected = isSelected;
          }
        }
        return element;
      });
      setTurnos(newTurnos);
    }
  };
  // -------------------------  funciones  ----------------------------

  // -------------------------  useEffect  ----------------------------
  useEffect(() => {
    let nextStep = (isCorrect, data) => {
      if (isCorrect && data) {
        data = data.filter((e) => !e.presente);

        const turnosOrdenados = OrderTurnos(
          data,
          filtroHorario,
          minutosToleranciaRecepcion,
          minRecepcionVariosTurnos,
          false
        );

        const kinesioVerificaRecepcion = turnosOrdenados.filter(
          (turno) => turno.type === "kinesioVerificacion"
        );
        const osValidacionInterna = turnosOrdenados.filter(
          (turno) => turno.type === "osValidacionInterna"
        );
        const noPermiteCheckIn = turnosOrdenados.filter(
          (turno) => turno.type === "noPermiteCheckIn"
        );
        const practicas = turnosOrdenados.filter(
          (turno) => turno.type === "practica"
        );

        if (kinesioVerificaRecepcion.length > 0) {
          setTurnosSeleccionado(kinesioVerificaRecepcion)(
            turnosSeleccionadosDispatch
          );
          const idTipoPuntoControl = 12;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (osValidacionInterna.length > 0) {
          setTurnosSeleccionado(osValidacionInterna)(
            turnosSeleccionadosDispatch
          );
          const idTipoPuntoControl = 13;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        } else if (noPermiteCheckIn.length > 0) {
          setTurnosSeleccionado(noPermiteCheckIn)(turnosSeleccionadosDispatch);
          const idTipoPuntoControl = 1;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        }
        //  else if (practicas.length > 0) {
        //   setTurnosSeleccionado(practicas)(turnosSeleccionadosDispatch);
        //   const idTipoPuntoControl = 2;
        //   setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
        //   setPaso("PuntoControl")(pasoDispatch);
        // }
        else {
          setLoading(false);
          setTurnos(turnosOrdenados);
        }
        setTurnos(turnosOrdenados);
      } else {
        setLoading(false);
      }
    };
    if (loading) {
      wsGetTurnosPacienteDelDiaQr(nextStep)(turnosAutoCheckInDispatch);
    }
    filaVirtualReset()(filaVirtualDispatch);
  }, []);
  // -------------------------  useEffect  ----------------------------

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />

      <LayoutPasos
        volverTo={"/autocheckin"}
        handleClick={volver}
        title={"TENGO TURNO"}
        subtitle={
          "Éstos son tus turnos para hoy. Tocá el que querés y luego presioná el botón 'Recepcionarme'."
        }
      >
        {!loading && (
          <ContainerP5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            <BodyContainerP5>
              {turnos
                ? turnos.map((element, key) => {
                    if (element?.type === "ausente") {
                      return (
                        <CardAusente
                          title={element.especialidad}
                          horario={element.hora}
                          sede={element.centro}
                          medico={element.medico}
                          key={key}
                          setTurnos={setTurnos}
                          turnos={turnos}
                          id={element.idturno}
                          actived={element.selected}
                          flgSoloConsulta={element.flgSoloConsulta}
                        />
                      );
                    } else {
                      return (
                        <CardCheck
                          title={element.especialidad}
                          horario={element.hora}
                          sede={element.centro}
                          medico={element.medico}
                          key={key}
                          setTurnos={setTurnos}
                          turnos={turnos}
                          id={element.idturno}
                          actived={element.selected}
                          flgSoloConsulta={element.flgSoloConsulta}
                          setSelected={(isSelected) =>
                            handleSeleccionar(element, isSelected)
                          }
                        />
                      );
                    }
                  })
                : ""}

              {turnos.length === 0 || !turnos ? (
                <ContainerSinTurno>
                  <AlertIconFilled
                    height={"70"}
                    width={"70"}
                    color={"var(--color-latex10)"}
                  />
                  <span className="title">
                    No se encotraron turnos para el día de hoy
                  </span>
                </ContainerSinTurno>
              ) : (
                ""
              )}
              {loading ? (
                ""
              ) : (
                <ContainerButton>
                  <>
                    {turnos.length > 0 ? (
                      <ButtonP5 onClick={handleClickButton}>
                        Recepcionarme
                      </ButtonP5>
                    ) : (
                      ""
                    )}
                  </>
                </ContainerButton>
              )}
            </BodyContainerP5>
          </ContainerP5>
        )}
      </LayoutPasos>
    </>
  );
};

export default TurnosDelDia;
